import store from "./index";
import router from "../router";

export default {
  state: {
    userInfo: null
  },
  getters: {},
  mutations: {
    setUserInfo(state, val) {
      state.userInfo = val;
      localStorage.setItem('qihuibao-web-userInfo',JSON.stringify(val))
    }
  },
  actions: {
    async getUserInfo({ commit, state }) {
      return new Promise((resolve,reject) => {
        if (state.userInfo && state.userInfo.userId > 0) {
          resolve(state.userInfo);
        } else {
          this.$axios.get("/app/api/user/details").then(res => {
            commit("setUserInfo", res.data);
            resolve(res.data);
          }).catch(error => {
            store.dispatch("logout").then(() => {
              router.replace({ name: "home" });
              router.go(0)
            });
            reject(error)
          });
        }
      });
    }
  }
};
